import { api } from './api.js';

const CLIENT_ACTIONS = new Set(['assistant.command', 'lead.view.client', 'page.view']);

/** Fire-and-forget client activity log (terminal commands, etc.). */
export function logClientActivity(action, detail = {}, opts = {}) {
  if (!CLIENT_ACTIONS.has(action)) return;
  api('/api/activity', {
    method: 'POST',
    body: {
      action,
      detail,
      resource_type: opts.resourceType || null,
      resource_id: opts.resourceId || null,
    },
  }).catch(() => {});
}

export function logTerminalCommand(command, mode) {
  const text = String(command || '').trim();
  if (!text) return;
  logClientActivity('assistant.command', { command: text.slice(0, 500), mode: mode || null });
}
